// extracted by mini-css-extract-plugin
module.exports = {"title":"_7a3fb80146--title--Z6ddE","subtitle":"_7a3fb80146--subtitle--ahM_r","documents":"_7a3fb80146--documents--OJSxY"};